/*
 * @Author: Merlin
 * @Date: 2025-03-13 16:01:44
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-01 14:08:52
 * @Description: 
 */
import { defineStore } from 'pinia';

const optionInitialState = {
    number: '', // 自动下注的次数（每局开始时都会减一）
    stopOnProfit: '', // 盈利停止金额
    stopOnLoss: '', // 损失停止金额
    maxBetAmount: '',  // 最大下注金额
    onWinReset: true, // 值为 true 表示“需要”复位，需要在赢时将下注的金额改为初始金额 
    onLossReset: true,
    onWin: '', // 若值为5，表示赢时上涨5%
    onLoss: '',
    // ↑ 以上是【表单】内容
    // ↓ 辅助自动模式运转的其它变量  
    isAutoBetting: false, // 自动下注开始时赋值为 true, 结束时改为 true。同时一旦监测到被外界改为 false, 应停止自动下注 
};

type OptionState = Partial<typeof optionInitialState>;

export const useAutoOptionStore = defineStore('autoOption', {
    state: () => ({
        ...optionInitialState,
    }),
    actions: {
        setState(partialState: OptionState) {
            Object.assign(this, partialState);
        },
        // 👇 状态归零 
        renew(partialState?: OptionState): OptionState {
            Object.assign(this, {
                ...optionInitialState, // 清空其它游戏的旧值，改为初始值 
            });
            return this;
        },
    },
    getters: {
        getState: (state) => state,
        /**
         * 自动模式时待下注的局的数量 
         */
        sRoundsRest(state){
            const desc = useNuxtApp().$i18n.t('commonInfo.restRound'); 
            let sLeft = '∞';
            if (Number(state.number) > 0){
                sLeft = state.number;
            }
            return `${desc} ${sLeft}`;
        },
    },
});


